import React from "react";
import classNames from "classnames"
import * as styles from "./SwiperSlider.module.scss"

const slides = [
	{ img: "/images/partners/geopop.svg", name: "Geopop" },
	{ img: "/images/partners/nm.svg", name: "Nexus Mentis" },
	{ img: "/images/partners/b2.svg", name: "B2" },
	{ img: "/images/partners/burt.svg", name: "Burt Intelligence" },
	{ img: "/images/partners/backlite.svg", name: "Backlite" },
	{ img: "/images/partners/schibsted.svg", name: "Schibsted" },
	{ img: "/images/partners/dragoman.svg", name: "Dragoman" },
];

const Marquee6Visible: React.FC = () => {
	return (
		<div className={styles.wrap}>
			<div className={styles.itemsWrap}>
				<div className={classNames(styles.items, styles.marquee)}>
					{
						slides.map((item, index) => (
							<div key={index} className={styles.item}>
								<img src={item.img} height={120} alt="" />
							</div>
						))
					}
				</div>
				<div aria-hidden="true" className={classNames(styles.items, styles.marquee)}>
					{
						slides.map((item, index) => (
							<div key={index} className={styles.item}>
								<img src={item.img} height={120} alt="" />
							</div>
						))
					}
				</div>
			</div>

		</div>
	);
};

export default Marquee6Visible;
